import { createElement } from 'react';
import './title-2.scss';
const Title2 = ({ title = '标题标题', color = '#144477', tipColor = '#388AF7', ...otherProps }) => {
    const _otherProps = otherProps || {};
    const colorStyle = color ? { color } : {};
    const tipColorStyle = tipColor ? { 'backgroundColor': tipColor } : {};
    return (createElement("div", { className: "custom-title-2", ..._otherProps },
        createElement("div", null,
            createElement("div", { className: "tips", style: tipColorStyle }),
            createElement("span", { style: colorStyle }, title))));
};
Title2.displayName = 'Title2';
export default Title2;
